import createIcon from '../../createIcon';

/**
 * @component @name FoodBank
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNS41TDE4IDEwVjE5SDZWMTBMMTIgNS41Wk0xMiAzTDQgOVYyMUgyMFY5TDEyIDNaTTExLjUgOS41VjEyLjVIMTFWOS41SDEwVjEyLjVIOS41VjkuNUg4LjVWMTIuNUM4LjUgMTMuMzMgOS4xNyAxNCAxMCAxNFYxOEgxMVYxNEMxMS44MyAxNCAxMi41IDEzLjMzIDEyLjUgMTIuNVY5LjVIMTEuNVpNMTMgMTEuNVYxNC41SDE0VjE4SDE1VjkuNUMxMy45IDkuNSAxMyAxMC40IDEzIDExLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FoodBank = createIcon('FoodBank', [
  [
    'path',
    {
      d: 'M12 5.5L18 10V19H6V10L12 5.5ZM12 3L4 9V21H20V9L12 3ZM11.5 9.5V12.5H11V9.5H10V12.5H9.5V9.5H8.5V12.5C8.5 13.33 9.17 14 10 14V18H11V14C11.83 14 12.5 13.33 12.5 12.5V9.5H11.5ZM13 11.5V14.5H14V18H15V9.5C13.9 9.5 13 10.4 13 11.5Z',
      key: 'cq1bva',
    },
  ],
]);

export default FoodBank;
